import { Phone, ArrowRight, Star, MapPin } from "lucide-react";
import { BUSINESS, HERO_BG } from "@/data/site";

export const Hero = () => {
  return (
    <section id="top" data-testid="hero-section" className="relative min-h-[100svh] flex items-end overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src={HERO_BG}
          alt="Precision Handyman completed project"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/85 to-black/40" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-black/60" />
      </div>

      <div className="relative z-10 mx-auto max-w-7xl w-full px-5 md:px-8 pb-16 pt-28 md:pb-24">
        <div className="max-w-3xl">
          <div
            data-testid="veteran-badge"
            className="inline-flex items-center gap-2 border border-zinc-700 bg-zinc-900/70 px-4 py-2 mb-7"
          >
            <Star className="h-4 w-4 text-red-500" fill="currentColor" />
            <span className="text-xs font-bold tracking-[0.28em] uppercase text-zinc-100">
              {BUSINESS.tagline}
            </span>
          </div>

          <h1 className="font-heading uppercase leading-[0.9] text-white text-6xl sm:text-7xl lg:text-8xl">
            <span className="block">Precision</span>
            <span className="block text-red-600">Handyman</span>
            <span className="block">Services</span>
          </h1>

          <p className="mt-6 text-lg md:text-xl text-zinc-300 max-w-xl leading-relaxed">
            {BUSINESS.motto} From small repairs to major projects, we get the job
            done right the first time.
          </p>

          <div className="mt-9 flex flex-col sm:flex-row gap-4">
            <a
              href="#contact"
              data-testid="hero-estimate-btn"
              className="group inline-flex items-center justify-center gap-2 bg-red-600 hover:bg-red-700 px-8 py-4 text-sm font-bold uppercase tracking-widest text-white transition-colors duration-150"
            >
              Get a Free Estimate
              <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform duration-150" />
            </a>
            <a
              href={BUSINESS.phoneHref}
              data-testid="hero-call-btn"
              className="inline-flex items-center justify-center gap-2 border-2 border-zinc-700 hover:border-red-600 px-8 py-4 text-sm font-bold uppercase tracking-widest text-white transition-colors duration-150"
            >
              <Phone className="h-4 w-4" />
              {BUSINESS.phone}
            </a>
          </div>

          <div className="mt-9 flex items-center gap-2 text-sm text-zinc-400">
            <MapPin className="h-4 w-4 text-red-500" />
            <span className="font-semibold tracking-wide">
              Proudly Serving {BUSINESS.serviceArea}
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};
